// extracted by mini-css-extract-plugin
module.exports = {"form":"settings_form__U8vt_","imageUpload":"settings_imageUpload__3DgnQ","message":"settings_message__3lZdl"};